enum formType {
    ADD_FORM = 'add',
    EDIT_FORM = 'edit',
}

export default formType;
